const PricingAndFareEngineComponent = () => import("@/views/pricingAndFareEngine/index.vue");

export default {
    path: "pricingAndFareEngine",
    meta: { label: "Pricing And Fare Engine" },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "",
            meta: {
                requiresAuth: true,
            },
            component: PricingAndFareEngineComponent,
        },
        // {
        //     path: "view/:id",
        //     meta: {
        //         requiresAuth: true,
        //     },
        //     component: ViewBookingsComponent,
        // },
    ],
};
